
export default angular.module('installer.external-validator', ['Ring.message-bundle']).
  directive('externalValidator', RingMessageBundle => ({
    require: 'ngModel',
    link: (scope, iElement, iAttr, ngModel) => {
      const name = iAttr.name;
      if (!name) {
        throw new Error('name attribute should been set to use external-validator');
      }
      const prefix = iAttr.externalPrefix || '';
      const uniqueValidatorId = `${prefix }_${ name }_external`;
      let errorMessage = null;

      RingMessageBundle[`form_${ uniqueValidatorId}`] = () => errorMessage;

      /**
         * Save error message on changes
         */
      scope.$watch(() => scope.$eval(iAttr.externalValidator), newValue => {
        errorMessage = newValue;
        ngModel.$setValidity(uniqueValidatorId, !errorMessage);
        /**
           * Force dirty to be sure that validation message will display
           */
        if (newValue) {
          ngModel.$setDirty(true);
        }
      });

      /**
         * Reset validation error on input change
         */
      if (!iAttr.externalDisableClean) {
        scope.$watch(() => ngModel.$viewValue, () => {
          ngModel.$setValidity(uniqueValidatorId, true);
        });
      }

    }
  }));



// WEBPACK FOOTER //
// ./src/blocks/external-validator/external-validator.js